// extracted by mini-css-extract-plugin
module.exports = {"Fycenter":"fps_Fycenter_z8AxB","Fyheader":"fps_Fyheader_2Fp3v","fmar":"fps_fmar_3Ev3Q"};